export const VARIETY_CREATE_REQUESTED = 'VARIETY_CREATE_REQUESTED';
export const VARIETY_CREATE_SUCCEEDED = 'VARIETY_CREATE_SUCCEEDED';
export const VARIETY_CREATE_FAILED = 'VARIETY_CREATE_FAILED';

export const VARIETIES_SET = 'VARIETIES_SET';

export const VARIETY_CREATE_NAMESPACE = 'VARIETY_CREATE';

export const VARIETY_UPDATE_NAMESPACE = 'VARIETY_UPDATE';
export const VARIETY_UPDATE_REQUESTED = 'VARIETY_UPDATE_REQUESTED';
export const VARIETY_UPDATE_SUCCEEDED = 'VARIETY_UPDATE_SUCCEEDED';
export const VARIETY_UPDATE_FAILED = 'VARIETY_UPDATE_FAILED';
